import React, { Fragment } from "react"
import { ButtonRow, MiniButton } from "../UI/Button/Button";
import { scrollToTop } from "./../../utils/utils"
import HorizontalRule from "./../UI/HorizontalRule/HorizontalRule"
import VerifyClubNumber from "./FormVerification/ClubNumber";
import VerifyPersonalData from "./FormVerification/PersonalData";
import VerifyTravelDocument from "./FormVerification/TravelDocument";
import VerifyEmergency from "./FormVerification/Emergency";
import { createManifestMailText as createMailText } from "../../services/createManifestMailService"

const ManifestVerification = (props) => {
  if (!props.isValid) {
    props.history.replace("/manifest/register")
    return null
  }

  if (process.env.NODE_ENV === "development") {
    console.log(createMailText(props.values, "client"))
  }
  
  scrollToTop()
  
  return (
    <Fragment>
      <Header />
      <VerifyPersonalData {...props} />
      <VerifyTravelDocument {...props} />
      <VerifyClubNumber {...props} />
      <VerifyEmergency {...props} />
      <Footer {...props} />
    </Fragment>
  )
}

const Header = () => (
  <Fragment>
    <h1 className="h1 text-center">
      Bordmanifest
    </h1>
    <HorizontalRule type="wave" />
    <p className="text-center text-grey">
      Bitte überprüfen Sie ihre Daten. 
    </p>
    <HorizontalRule />
  </Fragment>
)

const Footer = (props) => {
  return (
    <Fragment>
      <HorizontalRule />
      <RenderBack {...props} />
    </Fragment>
  )
}

const RenderBack = ({isSubmitting, isValid}) => {
  return (
    <Fragment>
      <ButtonRow justifyItems="space-around">
        <MiniButton 
          link="/manifest/register"
          className="mini-button"
          large={true}
        >
          Zurück
        </MiniButton>
        <button 
          className="mini-button" 
          type="submit" 
          disabled={!isValid || isSubmitting}
        >
          Absenden
        </button>
      </ButtonRow>
      <HorizontalRule />
    </Fragment>
  )
}

export default ManifestVerification